import React, { FC } from 'react';
import { IconProps } from '../types';
import { iconDefaultProps } from '../const';
import IconStyled from '../icon.styled';

const IconAngleLeft: FC<IconProps> = ({ $size, ...rest }) => (
  <IconStyled {...{ $size, ...rest }}>
    <svg width={$size} height={$size} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 32">
      <path d="M19.733 3.733L16 0 0 16l16 16 3.733-3.733L7.466 16z" />
    </svg>
  </IconStyled>
);

IconAngleLeft.defaultProps = iconDefaultProps;
IconAngleLeft.displayName = 'IconAngleLeft';

export default IconAngleLeft;
